/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type InitializeOracleArgs = {
  /** Nonce for PDA derivation (allows multiple oracles per authority) */
  nonce: bigint;
  /** Optional quote mint for validation (use Pubkey::default() if not needed) */
  quoteMint: Address;
};

export type InitializeOracleArgsArgs = {
  /** Nonce for PDA derivation (allows multiple oracles per authority) */
  nonce: number | bigint;
  /** Optional quote mint for validation (use Pubkey::default() if not needed) */
  quoteMint: Address;
};

export function getInitializeOracleArgsEncoder(): FixedSizeEncoder<InitializeOracleArgsArgs> {
  return getStructEncoder([
    ['nonce', getU64Encoder()],
    ['quoteMint', getAddressEncoder()],
  ]);
}

export function getInitializeOracleArgsDecoder(): FixedSizeDecoder<InitializeOracleArgs> {
  return getStructDecoder([
    ['nonce', getU64Decoder()],
    ['quoteMint', getAddressDecoder()],
  ]);
}

export function getInitializeOracleArgsCodec(): FixedSizeCodec<
  InitializeOracleArgsArgs,
  InitializeOracleArgs
> {
  return combineCodec(
    getInitializeOracleArgsEncoder(),
    getInitializeOracleArgsDecoder(),
  );
}
